module.exports = "";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/components/fields/field/field.jade
// module id = 235
// module chunks = 0